import React, { Component } from 'react';

import { Icon, Toast } from 'antd-mobile';
import { getOrderList } from '../../service/chat-service';

import styles from './styles.module.less';

import orderEmpty from './empty_order.png';

/**
 * 支付张泰
 */
const payStatus = {
  0: '待付款',
  2: '已付款',
  3: '已退货',
};

/**
 * 物流-我的订单
 */
class MyOrder extends Component {
  end = false;

  constructor(props) {
    super(props);
    this.state = {
      pageNum: 1,
      pageSize: 10,
      dataList: [],
      loading: false,
    };
  }

  componentDidMount() {
    window.document.title = '我的订单';
    this.loadData();
    this.addScrollEvent();
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  loadData = async (pageNum2) => {
    const { pageNum } = this.state;
    const pageNum1 = pageNum2 || pageNum;
    const { pageSize, dataList } = this.state;

    if (this.end) return false;
    this.setState({ loading: true });

    try {
      const { list } = (await getOrderList(pageNum1, pageSize)) || {};

      let orderList = dataList;
      if (Array.isArray(list) && list.length) {
        if (list.length < pageSize) this.end = true;
        orderList = dataList.concat(list);
      }
      this.setState({ dataList: orderList, pageNum: pageNum1, loading: false });
    } catch (e) {
      Toast.show(e.message);
      this.setState({ loading: false });
    }
    return true;
  };

  scrollBottomLoad = () => {
    const { pageNum, loading } = this.state;
    if (this.end || loading) return false;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const bodyHeight = document.getElementById('order_content_H9').clientHeight;
    const { clientHeight } = document.documentElement;

    if (scrollTop + clientHeight + 50 >= bodyHeight) {
      this.loadData(pageNum + 1);
    }
    return true;
  };

  addScrollEvent = () => {
    window.addEventListener('scroll', this.scrollBottomLoad);
  };

  removeScrollEvent = () => window.removeEventListener('scroll', this.scrollBottomLoad);

  renderOrderList = () => {
    const { dataList } = this.state;
    return dataList.map((item) => (
      <div className={styles.orderItem} key={item.orderId}>
        {/* 标题 */}
        <div className={styles.header}>
          <span>
            订单编号：
            <span>{item.orderId}</span>
          </span>
          <span className={styles.sendStatus}>{payStatus[item.status]}</span>
        </div>
        {/* 详情 */}
        <div className={styles.detail}>
          <div className={styles.left}>
            <img src={item.productImg} alt="" />
          </div>
          <div className={styles.right}>
            <p>{item.productName}</p>
            <p className={styles.money}>
              ¥
              {' '}
              {item.orderAmount
                ? (item.orderAmount / 100).toFixed(2)
                : '0:00'}
            </p>
            <div className={styles.bottom}>
              {item.specificationName && (
              <span>
                已选&quot;
                {item.specificationName}
                &quot;
              </span>
              )}
              <span className={styles.buyNumber}>
                x
                {item.orderNum}
              </span>
            </div>
          </div>
        </div>
        {/* 快递单号 */}
        {item.expressNo && (
        <div className={styles.header}>
          <span>
            {item.expressCom}
            ：
            {item.expressNo}
          </span>
        </div>
        )}
      </div>
    ));
  };

  renderEmpty = () => (
    <div className={styles.emptyContent}>
      <img src={orderEmpty} alt="" />
      <p className={styles.notice}>暂无订单</p>
    </div>
  );

  render() {
    const { dataList, loading } = this.state;
    return (
      <div className={styles.orderContent} id="order_content_H9">
        {dataList.length ? this.renderOrderList() : this.renderEmpty()}
        {loading && (
          <div className={styles.loading}>
            <Icon type="loading" />
          </div>
        )}
      </div>
    );
  }
}

export default MyOrder;
